<template>
  <th v-if="isHeader"></th>
  <td v-else class="expand-indicator-cell" @click="onClick">
    <i :class="expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'" class="expand-hint-icon"></i>
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: {
    expanded: function () {
      if (this.$parent && this.$parent.isVisibleDetailRow) {
        return this.$parent.isVisibleDetailRow(this.rowData.joint_id)
      }
      return false
    }
  },
  methods: {
    onClick: function () {
      if (this.$parent && this.$parent.toggleDetailRow) {
        this.$parent.toggleDetailRow(this.rowData.joint_id)
      }
    }
  }
}
</script>

<style>
.expand-indicator-col {
  width: 1px;
  padding: 4px 8px !important;
}
.expand-indicator-cell {
  cursor: pointer;
  vertical-align: middle !important;
}
.expand-hint-icon {
  color: #999;
  font-size: 12px;
  transition: transform 0.15s ease;
}
</style>



// WEBPACK FOOTER //
// VueTableExpandIndicator.vue?1063f4f1